import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { healthProviderId: Number }
  static targets = [
    "projects",
    "cases",
    "fmkUsage",
    "videoCalls",
    "assignedVideoEquipments",
    "ddvUsage",
    "webPatientUsage",
    "webPatientFmkStatus"
  ]

  connect() {
    // Load components sequentially with slight delays to avoid overwhelming the server
    this.loadComponent("projects", "load_projects", 100);
    this.loadComponent("cases", "load_cases", 300);
    
    if (this.hasWebPatientFmkStatusTarget) {
      this.loadComponent("webPatientFmkStatus", "load_web_patient_fmk_status", 400);
    }
    
    this.loadComponent("fmkUsage", "load_fmk_usage", 500);

    if (this.hasAssignedVideoEquipmentsTarget) {
      this.loadComponent("assignedVideoEquipments", "load_assigned_video_equipments", 700);
    }
    if (this.hasVideoCallsTarget) {
      this.loadComponent("videoCalls", "load_video_calls", 900);
    }

    if (this.hasWebPatientUsageTarget) {
      this.loadComponent("webPatientUsage", "load_web_patient_usage", 1100);
    }
    if (this.hasDdvUsageTarget) {
      this.loadComponent("ddvUsage", "load_ddv_usage", 1300);
    }
  }

  loadComponent(targetName, actionName, delay) {
    setTimeout(() => {
      const target = this[`${targetName}Target`];
      if (target) {
        fetch(`/health_providers/${this.healthProviderIdValue}/${actionName}`, {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => response.text())
          .then(html => {
            target.innerHTML = html;
            this.applyCardToggle(target);
          })
          .catch(error => {
            console.error(`Error loading ${targetName}:`, error);
            target.innerHTML = `
            <div class="card">
              <div class="card-body text-center text-danger">
                <i class="bi bi-exclamation-triangle"></i>
                Error loading content. Please refresh the page.
              </div>
            </div>
          `;
          });
      }
    }, delay);
  }

  applyCardToggle(container) {
    // Apply card toggle functionality to card-toggle elements within the container
    const cardToggles = container.querySelectorAll('.card-toggle');

    cardToggles.forEach(card => {
      const header = card.querySelector('.card-header');
      const body = card.querySelector('.card-body');

      if (header && body) {
        body.style.display = 'none';

        if (!header.querySelector('.bi-caret-down, .bi-caret-up')) {
          const icon = document.createElement('i');
          icon.className = 'bi bi-caret-down';
          header.prepend(icon);
        }

        if (!header.hasAttribute('data-toggle-applied')) {
          header.setAttribute('data-toggle-applied', 'true');
          header.addEventListener('click', () => {
            const upArrow = header.querySelector('.bi-caret-up');
            const downArrow = header.querySelector('.bi-caret-down');

            if (upArrow) {
              upArrow.className = 'bi bi-caret-down';
            } else if (downArrow) {
              downArrow.className = 'bi bi-caret-up';
            }

            if (body.style.display === 'none') {
              body.style.display = 'block';
            } else {
              body.style.display = 'none';
            }
          });
        }
      }
    });
  }
}